import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import GeofenceService from '../../../services/bioplus-services/geofence';
import { useUserContext } from '../../../hooks/UserContext';
import { useCompany } from '../../../hooks/CompanyContext';
import { transformKeys } from '../../../helper/dataFormat';
import MapDependencies from './mapDependencies';
import {
  CompanyContainer,
  HeaderTitle,
  SwitchButtonWrapper,
  SwitcherLabel,
} from '../../../services/settings/appStyle/global.style';
import { IconButton, Switch } from '../../../Components/uielements';
import { FindMeLogo, WhiteLocationIcon } from '../../../Components/icons';
import { StyledContainer } from './geofence.style';
import { IntlMessages } from '../../../helper/langHelper';
// import { getFriendsLocation } from '../../../services/bioplus-services/friendsLocation';

export const getGeofences = async (userRole, companyFilter) => {
  switch (userRole.role) {
    case 'PARTNER': {
      return await GeofenceService.listAllByPartner(userRole?.partnerId, companyFilter);
    }
    case 'ADMIN': {
      return await GeofenceService.listAllByAdmin(companyFilter);
    }
    case 'OWNER': {
      return await GeofenceService.listAllByCompany(userRole.companyId?.id, {});
    }
    case 'EMPLOYEE': {
      return await GeofenceService.listAllByCompany(userRole.companyId?.id, {});
    }

    case 'VISITOR': {
      return await GeofenceService.listAllByCompany(userRole.companyId?.id, {});
    }
    case 'MANAGER': {
      return await GeofenceService.listAllGeofencesByManager(
        userRole.companyId?.id,
        userRole?.premiseId
      );
    }
    case 'CORPORATE_ADMIN': {
      return await GeofenceService.listAllByParent(userRole.companyId?.id, {});
    }
    default:
      return [];
  }
};

export const getOverlay = (geofence) => {
  if (!geofence?.polygon) return [];
  const points = [];

  for (const point of geofence.polygon) {
    points.push({
      lat: point.latitude,
      lng: point.longitude,
    });
  }

  return points;
};

const GeofenceMap = () => {
  const [points, setPoints] = useState([]);
  const [viewFriendLocation, setViewFriendLocation] = useState(false);
  const navigate = useNavigate();
  const userRole = useUserContext()?.company;
  const companyFilter = useCompany()?.company?._id;
  const isManager = userRole?.role === 'MANAGER';

  const query = useQuery(['allGeofences', isManager, userRole?.companyId, companyFilter], () =>
    getGeofences(userRole, companyFilter)
  );

  // const friendsLocationQuery = useQuery(['friendsLocation'], () => getFriendsLocation(), {
  //   enabled: viewFriendLocation,
  //   refetchOnWindowFocus: false,
  //   staleTime: 30000,
  //   onError: (error) => {
  //     alert('No friend locations available to show.');
  //   },
  // });

  const location = useLocation();
  const data = location?.state;
  const isView = location?.state?.isView;

  useEffect(() => {
    if (query.isFetched) {
      const fences = isManager ? query?.data?.geofences : query.data ?? [];
      const overlays = [];
      const sortedFences = fences?.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
      for (const fence of sortedFences) {
        overlays.push(getOverlay(fence));
      }

      setPoints(overlays);
    }
  }, [isManager, query.data, query.data?.geofences, query.isFetched]);

  const handleSwitchToggle = () => {
    setViewFriendLocation(!viewFriendLocation);
  };

  return (
    <StyledContainer>
      <CompanyContainer>
        <HeaderTitle>
          <IntlMessages id="module.title.geofence.map" />
        </HeaderTitle>

        <div style={{ display: 'flex', gap: '20px' }}>
          {!companyFilter && (
            <SwitchButtonWrapper>
              <FindMeLogo style={{ width: '30px', height: '30px' }} />
              <SwitcherLabel>View Location(FM247)</SwitcherLabel>
              <Switch handleToggle={handleSwitchToggle} checked={viewFriendLocation} />
            </SwitchButtonWrapper>
          )}
          <IconButton
            text={<IntlMessages id="button.text.back" />}
            onClick={() => navigate('/geofences')}
            icon={<WhiteLocationIcon style={{ width: '20px', height: '19px' }} />}
          />
        </div>
      </CompanyContainer>
      <MapDependencies
        markers={points}
        geofenceData={isManager ? query?.data?.geofences : query?.data ?? []}
        // friendsLocationData={friendsLocationQuery?.data}
        fetchData={() => {
          query.refetch();
        }}
        stateData={transformKeys(data?.data?.polygon)}
        geoFence={data?.data}
        isView={isView}
        navigate={navigate}
        isViewFriendLocation={viewFriendLocation}
      />
    </StyledContainer>
  );
};

export default GeofenceMap;
